import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
import React from 'react';
import { useBlinkContextForGlobalNav } from "../../contexts/global-nav-blink-context";
import { HelpMenu } from "./help-menu";
export const HelpMenuContainer = ({ isPendoHelpEnabled, }) => {
    const { sessionService, metricsService } = useBlinkContextForGlobalNav();
    const sendMixpanelEvent = () => {
        metricsService.collectEvent(new UserAction(userActionTypeEnum.TOP_NAV_INFO_CENTER_CLICK), {});
    };
    const { getReleaseVersion, getBaseReleaseVersion, getHelpConfig, getOnlineDocUrl, isSaaSCluster, } = sessionService;
    return (React.createElement(HelpMenu, { getBaseReleaseVersion: getBaseReleaseVersion, getHelpConfig: getHelpConfig, getReleaseVersion: getReleaseVersion, isPendoHelpEnabled: isPendoHelpEnabled, sendMixpanelEvent: sendMixpanelEvent, getOnlineDocUrl: getOnlineDocUrl, isSaaSCluster: isSaaSCluster }));
};
//# sourceMappingURL=help-menu.container.js.map